import { render, staticRenderFns } from "./PortalQrModel.vue?vue&type=template&id=0807ad47&scoped=true&"
import script from "./PortalQrModel.vue?vue&type=script&lang=js&"
export * from "./PortalQrModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0807ad47",
  null
  
)

export default component.exports